import { useEffect } from "react";
import { Box, Typography, Stack } from "@mui/material";
import ScrollToTop from "../nav/ScrollToTop";
import SfsCategoryButton from "./SfsCategoryButton";
import SfsSummary from "./SfsSummary";
import SfsInputRow from "./SfsInputRow";
import ActionButton from "../account/ActionButton";
import { useSfs } from "../../context/SfsProvider";
import { useAnalytics } from "../../context/AnalyticsProvider";

function SfsAdditionalDebt({ handleBack, handleComplete }) {
  /* The additional debt component */

  const {
    sfsAdditionalDebt,
    setSfsAdditionalDebt,
    setSfsCategoryTotal,
    categories,
    setCategories,
    changeCategory,
    selectedCategory,
    setSelectedCategory,
    addDebtValue
  } = useSfs();
  const { setTag } = useAnalytics();
  const setItem = (newItem) => {
    // Update item in state with changes
    const newAdditionalDebtValues = sfsAdditionalDebt.map((item) =>
      item.category === newItem.category && item.title === newItem.title
        ? newItem
        : item
    );
    setSfsAdditionalDebt(newAdditionalDebtValues);
    setSfsCategoryTotal(newItem, newAdditionalDebtValues);
  };

  useEffect(() => {
    // Set data to additional debt on load
    if (sfsAdditionalDebt) {
      // Get unique array of categories in data
      const uniqueCategoryList = sfsAdditionalDebt
        .map((item) => item.category)
        .filter((value, index, self) => self.indexOf(value) === index);
      // Convert categories to objects with selected flag
      const uniqueCategories = uniqueCategoryList.map((item, idx) => ({
        name: item,
        selected: idx === 0 ? true : false,
      }));
      setCategories(uniqueCategories);
      setSelectedCategory(uniqueCategories[0].name);
    }
  }, []);

  return sfsAdditionalDebt && categories ? (
    <>
      <ScrollToTop />
      <Typography fontSize={22} fontWeight={"bold"} paddingBottom={2}>
        Additional Debt
      </Typography>
      <Stack
        sx={{
          mt: 2,
        }}
        spacing={8}
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        <Box id='add-debt-container' sx={{ width: { xs: "100%", md: "55%" } }}>
          {/* Left column */}

          <Box sx={{ pb: 2 }}>
            {/* Sub category buttons */}
            {categories?.map((category, idx) => {
              return (
                <SfsCategoryButton
                  key={idx}
                  category={category}
                  changeCategory={changeCategory}
                />
              );
            })}
          </Box>

          <Box>
            {/* Sub category Inputs */}
            {sfsAdditionalDebt?.map((item, idx) =>
              item.category === selectedCategory ? (
                <SfsInputRow
                  key={idx}
                  item={item}
                  setItem={setItem}
                  maxValue={addDebtValue[item.category]}
                />
              ) : null
            )}
          </Box>

          {/* End of left column */}
        </Box>

        <Box sx={{ width: { xs: "100%", md: "45%" } }}>
          {/* Right column */}

          <SfsSummary
            id='monthly-debt-sum'
            title='Monthly Additional Debt Summary'
          />

          {/* Call To Action */}
          <Box sx={{
            pt: 4,
            textAlign: { xs: "center", md: "left" },
            display: "flex",
            flexDirection: "row"
          }}>
            <ActionButton
              id='back-btn'
              borderColor='primary.dark'
              buttonColor='transparent'
              buttonTextColor='primary.dark'
              buttonTitle='Back'
              variant='outlined'
              hoverColor='primary.dark'
              hoverBorderColor={"primary.dark"}
              hoverTextColor='secondary.contrastText'
              onClick={handleBack}
              sx={{ mr: 2 }}
            />
            <ActionButton
              id='save-continue-btn'
              variant='contained'
              buttonColor='secondary.main'
              buttonTextColor='primary.contrastText'
              borderColor='transparent'
              hoverColor='primary.contrastText'
              hoverBorderColor='secondary.main'
              hoverTextColor='secondary.main'
              buttonTitle=' Save & Continue'
              onClick={() => {
                handleComplete();
                setTag("sfs_complete");
              }}
            />
          </Box>

          {/* End of right column */}
        </Box>
      </Stack>
    </>
  ) : null;
}

export default SfsAdditionalDebt;
